<template>
  <el-dialog
    :visible="visible"
    :close-on-click-modal="false"
    custom-class="vip-card-popup"
    append-to-body
    width="100%"
    @close="handleClose"
  >
      <div class="vip-card-content tac">
          <div class="vip-card-btns df ai-c js-c">
              <a href="/my/myCoupon.php" target="_blank" class="btn btn-1"><span>查看优惠券</span></a>
              <button type="button" class="btn btn-2" @click="handleOpenVip"><span>立即开通VIP</span></button>
          </div>
          <img src="~@/assets/images/vip/vip_card/vip_card.png" alt="25优惠券+年VIP限时价" class="vip-card-img">
      </div>
      <!-- 关闭按钮 -->
      <button type="button" class="vip-card-close" aria-label="关闭" @click="handleClose"></button>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { tasteVipExpiredCoupon } from '@/api/vip/novice'

export default {
  name: 'VipCardPopup',
  data() {
    return {
      counter:0
    }
  },
  computed: {
    ...mapGetters(['token']),
    visible() {
      return this.$store.state.vipCard.visible
    },
    userMember() {
      return this.$store.state.home.UserInfo.member
    }
  },
  watch: {
    userMember: {
      deep: true,
      handler(member) {
       if(this.counter===0){// 只执行一次
          this.counter++
          this.handleUserMemberUpdate(member)
        }
      }
    }
  },
  created() {
    if (this.token) {
      this.getUserInfo()
    }
  },
  methods: {
    ...mapActions('vipCard', ['openVipCard', 'closeVipCard']),
    ...mapActions('home', ['getUserInfo']),
    async show(){
      let params = {
        show_error_msg:false,
        platform:2 //1pc 2m 3app ios 4app android
      }
      let res = await tasteVipExpiredCoupon(params);
      // console.log(res);
      if(res?.code!=0){
        return
      }
      
      this.openVipCard()
    },
    handleClose() {
      this.closeVipCard()
    },
    handleOpenVip() {
      location.href='/pay/wxpay1/buyvip_new.php?vip_type=15';
    },
    handleUserMemberUpdate(member) {
      // console.log('handleUserMemberUpdate:', member)
      if (member?.taste_vip_expired_popup?.show_popup) {
        setTimeout(()=>{
          this.show()
        },15000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .vip-card-popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: noviceFadeInUp2 .3s ease forwards;
    // transform: translate(-50%, -50%) translateY(0) scale(0.9);
    // animation: noviceFadeInUp .3s ease forwards;
    margin: 0;
    background: transparent;
    box-shadow: none;
    border: none;
    overflow: visible;
    /* background-color: rgba(0, 0, 0, 0.5); */
    z-index: 9999;

    .el-dialog__header {
        display: none;
    }

    .el-dialog__body {
        padding: 0;
        overflow: visible;
    }

    /* .vip-card-content {
        width: 750px;
        height: 863px;
        background: url('~@/assets/images/vip/vip_card/vip_card.png') no-repeat center center/100% 100%;
    } */

    .vip-card-img {
        width: 750px;
        height: 863px;
        vertical-align: middle;
    }

    .vip-card-btns {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 10px;

        .btn {
            display: block;
            width: 284px;
            height: 103px;
            cursor: pointer;
            background-color: transparent;
            border: none;
            outline: none;
            transition: all 0.3s;

            span {
                display: block;
                width: 100%;
                height: 100%;
                text-indent: -9999em;
                overflow: hidden;
            }
        }
    }

    .btn-1 {
        background: url('~@/assets/images/vip/vip_card/vip_cart_btn01.png') no-repeat center center/100% 100%;
    }

    .btn-2 {
        background: url('~@/assets/images/vip/vip_card/vip_cart_btn02.png') no-repeat center center/100% 100%;
    }

    .vip-card-close {
        width: 64px;
        height: 64px;
        background: url('~@/assets/images/vip/vip_card/m_close.png') no-repeat center/100% 100%;
        position: absolute;
        /* right: 0;
        top: 20px; */
        left: 50%;
        bottom: 0;
        transform: translate(-50%, 100%);
        z-index: 200;
        cursor: pointer;
    }
}
@keyframes noviceFadeInUp {
    from {
        opacity: 0;
        transform: translate(-50%, -50%) translateY(0) scale(0.9);
    }
    to {
        opacity: 1;
        transform: translate(-50%, -50%) translateY(10px) scale(0.9);
    }
}
@keyframes noviceFadeInUp2 {
    from {
        opacity: 0;
        transform: translate(-50%, -50%) translateY(0);
    }
    to {
        opacity: 1;
        transform: translate(-50%, -50%) translateY(10px);
    }
}
</style>
